import { ChevronDown } from 'lucide-react';
import { useEffect, useState } from 'react';
import './HotmartCheckoutButton.css';

const HOTMART_SCRIPT_SRC = 'https://static.hotmart.com/checkout/widget.min.js';
const HOTMART_CSS_HREF = 'https://static.hotmart.com/css/hotmart-fb.min.css';

let hotmartScriptPromise: Promise<void> | null = null;

export function loadHotmartScript(): Promise<void> {
  if (hotmartScriptPromise) return hotmartScriptPromise;

  if (!document.querySelector(`link[href="${HOTMART_CSS_HREF}"]`)) {
    const link = document.createElement('link');
    link.href = HOTMART_CSS_HREF;
    document.head.appendChild(link);
  }

  hotmartScriptPromise = new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${HOTMART_SCRIPT_SRC}"]`)) {
      resolve();
      return;
    }
    const script = document.createElement('script');
    script.src = HOTMART_SCRIPT_SRC;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Erro ao carregar script da Hotmart'));
    document.head.appendChild(script);
  });

  return hotmartScriptPromise;
}

interface HotmartCheckoutButtonProps {
  checkoutUrl: string;
}

const HotmartCheckoutButton = ({ checkoutUrl }: HotmartCheckoutButtonProps) => {
  const [scriptLoaded, setScriptLoaded] = useState(false);

  useEffect(() => {
    loadHotmartScript()
      .then(() => setScriptLoaded(true))
      .catch(() => console.error('Erro ao carregar script da Hotmart'));
  }, []);

  if (!scriptLoaded) return null;

  return (
    <a
      href={checkoutUrl}
      className="cdl-hotmart-btn hotmart-fb hotmart__button-checkout"
    >
      GARANTA SUA VAGA
      <ChevronDown className="ml-2 w-5 h-5 transition-transform" />
    </a>
  );
};

export default HotmartCheckoutButton;
